import UserEnquiryForm from './UserEnquiryForm.component';

export default UserEnquiryForm;
